import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { CardContainer } from '@/shared/components/card-container/card-container';
import { DetalheGrid } from '@/shared/components/layout/detalhe-grid/detalhe-grid';
import { DetalheItem } from '@/shared/components/layout/detalhe-grid/detalhe-item';

import { type LinhaTransferencia } from '../central-transferencia-tabela.config';
import { IdentificacaoPessoa } from '@/shared/components/pessoa/identificacao-pessoa/identificacao-pessoa';
import { VigenciaSolicitacao } from '../vigencia-solicitacao/vigencia-solicitacao';
import { BandeiraUf } from '../bandeira-uf/bandeira-uf';

/**
 * O cartão de uma solicitação na visão de card das três abas da Central.
 *
 * Existe porque o card declarativo do CustomTable não alcança os dois desenhos que a TABELA já tem:
 * o retrato com o badge do protocolo e os dois selos de vigência com a seta. O `pTemplate="cell"` só
 * é lido no modo tabela — era por isso que a mesma solicitação se lia de um jeito na tabela e de
 * outro no card.
 *
 * Reusa `app-identificacao-pessoa` e `app-vigencia-solicitacao`, os mesmos blocos da tabela: fonte
 * única, para as duas visões não divergirem na primeira alteração.
 *
 * NÃO desenha clique, seleção nem `aria-selected`: o CustomTable embrulha este template num
 * elemento que já faz as três coisas. Repetir o clique aqui dispararia a seleção duas vezes no
 * mesmo gesto, marcando e desmarcando a linha.
 */
@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-cartao-transferencia',
    standalone: true,
    imports: [CardContainer, DetalheGrid, DetalheItem, IdentificacaoPessoa, VigenciaSolicitacao, BandeiraUf],
    templateUrl: './cartao-transferencia.html',
    styleUrl: './cartao-transferencia.scss'
})
export class CartaoTransferencia {
    readonly linha = input.required<LinhaTransferencia>();
    /** Rótulo e valor da UF que a aba destaca — "UF Destino" na origem, "UF Origem" no destino. */
    readonly rotuloUf = input<string>('UF');
    readonly valorUf = input<string>('');
    readonly selecionado = input<boolean>(false);
}
